import { FormGroup } from "@angular/forms";

export function trimFormValues(form: FormGroup): void {
  if (!form || !form.controls) return;

  Object.keys(form.controls).forEach(key => {
    const control = form.get(key);
    const value = control?.value;

    if (typeof value === 'string') {
      control?.setValue(value.trim());
    } else if (value && typeof value === 'object' && !(value instanceof Date)) {
      trimFormValues(value as FormGroup);
    }
  });
}
